export { default as amountDivide } from './amountDivide';
